<cosmos-auth-layout
  [title]="'login.welcome' | translate"
  [subtitle]="'login.sign-in-subtitle' | translate"
>

  <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" novalidate>

    <div class="form-fields">

      <!-- Email -->
      <p-floatlabel variant="on" class="w-full">
        <input
          pInputText
          id="login-email"
          type="email"
          formControlName="email"
          class="w-full"
          autocomplete="email"
        />
        <label for="login-email">
          <i class="fa-solid fa-envelope me-2"></i>
          {{ 'login.email' | translate }}
        </label>
      </p-floatlabel>

      <!-- Password -->
      <p-floatlabel variant="on" class="w-full">
        <p-password
          inputId="login-password"
          formControlName="password"
          [feedback]="false"
          [toggleMask]="true"
          autocomplete="current-password"
          fluid
        />
        <label for="login-password">
          <i class="fa-solid fa-lock me-2"></i>
          {{ 'login.password' | translate }}
        </label>
      </p-floatlabel>

    </div>

    <!-- Forgot password -->
    <div class="form-forgot">
      <a routerLink="/recovery">{{ 'login.password-reset' | translate }}</a>
    </div>

    <div class="form-actions">

      <button
        pButton
        id="login-submit"
        type="submit"
        severity="primary"
        [label]="'login.button' | translate"
        [loading]="loading()"
        [disabled]="loginForm.invalid"
      ></button>

      @if (signupAllowed()) {
        <button
          pButton
          id="login-signup"
          type="button"
          severity="secondary"
          [label]="'login.signup' | translate"
          routerLink="/signup"
        ></button>
      }

    </div>

    @if (error()) {
      <div class="form-error">
        @if (error() === 'rate-limit') {
          <p-message severity="warn" styleClass="w-full">
            {{ 'login.error-rate-limit' | translate }}
          </p-message>
        } @else if (error() === 'role') {
          <p-message severity="warn" styleClass="w-full">
            {{ 'login.error-role' | translate }}
          </p-message>
        } @else {
          <p-message severity="error" styleClass="w-full">
            {{ 'login.error' | translate }}
          </p-message>
        }
      </div>
    }

  </form>

  <footer class="form-footer">
    <p>{{ 'login.restricted' | translate }}</p>
  </footer>

</cosmos-auth-layout>
